import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import Tooltip from 'ui-library/bs/Tooltip';
import {GRAY_DARK} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import runModal from 'ui-library/runModal';

import {LocalAssembly} from '../BulkAssemblyConstants';
import {getNextSlotIdx, getPreviousSlotIdx, slotHasSequences} from '../BulkAssemblyUtil';
import HomologyDetectionModal from './HomologyDetectionModal';

const DISABLED_MESSAGE =
  'To use automatic homology detection, you must select input sequences for both' +
  ' the current step and an adjacent step';

interface Props {
  assembly: LocalAssembly;
  slotIdx: number;
  changeBases: (bases: string) => void;
}

const DetectHomologyButton = (props: Props): JSX.Element => {
  const {assembly, changeBases, slotIdx} = props;

  const hasData =
    slotHasSequences(assembly, slotIdx) &&
    (slotHasSequences(assembly, getNextSlotIdx(assembly, slotIdx)) ||
      slotHasSequences(assembly, getPreviousSlotIdx(assembly, slotIdx)));

  const onClick = async (): Promise<void> => {
    if (!hasData) {
      return;
    }
    const homologyBases = await runModal(HomologyDetectionModal, {assembly, slotIdx});
    if (homologyBases) {
      changeBases(homologyBases);
    }
  };

  return (
    <Tooltip title={hasData ? 'Detect' : DISABLED_MESSAGE}>
      <BenchlingIcon
        dataTestAttrs={{component: 'DetectHomologyButton', element: 'root'}}
        className={css(styles.detectIcon, !hasData && styles.detectIconDisabled)}
        icon="detect"
        onClick={onClick}
      />
    </Tooltip>
  );
};

export default DetectHomologyButton;

const styles = StyleSheet.create({
  detectIcon: {
    position: 'absolute',
    right: '8px',
    top: '8px',
    cursor: 'pointer',
  },
  detectIconDisabled: {
    color: GRAY_DARK,
    cursor: 'default',
  },
});
